import React from 'react';
import '../styles/CloudMigrationHighlights.css';

const CloudMigrationHighlights = () => {
  const highlights = [
    {
      title: 'Expertise Across Leading Platforms',
      description:
        'Our certified professionals have deep experience with AWS, Microsoft Azure, Google Cloud, and hybrid solutions. We help you select and optimize the best fit for your business.',
      className: 'highlight-yellow',
    },
    {
      title: 'End-to-End Project Management',
      description:
        'We manage every phase, from assessment to post-migration support, ensuring clear communication and transparency.',
      className: 'highlight-green',
    },
    {
      title: 'Custom-Tailored Solutions',
      description:
        'Every business is unique. We design solutions to fit your industry, regulatory needs, and growth objectives.',
      className: 'highlight-pink',
    },
    {
      title: 'Change Management & Training',
      description:
        'We support your teams with training and documentation, ensuring a smooth transition and maximum user adoption.',
      className: 'highlight-blue',
    },
  ];

  return (
    <section className="cloud-migration-highlights">
      <div className="highlight-overlay">
        <h1 className="section-title">Why Choose Us for Cloud Migration?</h1>
        <div className="highlight-grid">
          {highlights.map((item, index) => (
            <div key={index} className={`highlight-item ${item.className}`}>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CloudMigrationHighlights;
